import { createContext, useContext, type ReactNode } from 'react';

import { fetchReplyDraftsGateway } from '../api/fetchReplyDraftsGateway';
import type { ReplyDraftsGateway } from '../ports/replyDraftsGateway';

/**
 * Which backend the reply draft hooks talk to. It defaults to the real one, so
 * the app mounts no provider; a test mounts one holding an in-memory gateway.
 *
 * The default matters beyond convenience: the native sheet is portalled to the
 * root overlay and loses every context the screen provides, so a provider the
 * screen mounted would never reach it.
 */
const ReplyDraftsGatewayContext = createContext<ReplyDraftsGateway>(fetchReplyDraftsGateway);

export function ReplyDraftsGatewayProvider({
  gateway,
  children,
}: {
  gateway: ReplyDraftsGateway;
  children: ReactNode;
}) {
  return (
    <ReplyDraftsGatewayContext.Provider value={gateway}>
      {children}
    </ReplyDraftsGatewayContext.Provider>
  );
}

export function useReplyDraftsGateway() {
  return useContext(ReplyDraftsGatewayContext);
}
